<template>
  <!--添加  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="AddList"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="跳转的连接" prop="linkTo">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.linkTo"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="显示几秒" prop="showSecond">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.showSecond"
                clearable
                type="number"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="开屏广告(1124×2208)"
              prop="advertisementUrl"
              ref="advertisementUrl"
              class="shadow"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="AddList.advertisementUrl"
                  :src="AddList.advertisementUrl"
                  class="avatar"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证

      if (this.AddList.advertisementUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false,
      videoUploadTag: false,
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      imgLoad: false, //加载load
      newsStatus: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      //添加的参数：
      AddList: {
        linkTo: "", //标题
        advertisementUrl: "", //长图
        showSecond: "", //摘要
      },
      toAdRule: {
        advertisementUrl: [
          { required: true, validator: valiIcon, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 封面图上传成功
    upSuccessCoverUrl(file) {
      this.AddList.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    upSuccess(file) {
      console.log(file, "-------------");
      this.AddList.advertisementUrl = file.entity;
      if (file.entity) {
        this.$refs.advertisementUrl.clearValidate();
      }
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/ad/kaiping/insert", {
            linkTo: this.AddList.linkTo, //标题
            advertisementUrl: this.AddList.advertisementUrl, //长图
            showSecond: this.AddList.showSecond, //主办单位
          }).then((res) => {
            if (res.success == true) {
              this.$router.push("/openScreen");
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .shadow {
      /deep/ .el-upload {
        width: 200px;
        height: auto;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: 0;
        border: 2px dashed #eee;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }

    /deep/ .el-upload-list--picture-card {
      margin: 0;
      display: inline;
      vertical-align: top;
      // display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
}
/deep/.el-dialog {
  margin-top: 0 !important;
}
</style>